import { useVotes } from '../context/VotesContext';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';

const protocol = window?.location.protocol || 'https:';

export const useFetchVote = ({ refs, setters, voteState, authorId }) => {
  const { votes, setVote } = useVotes();

  const { user } = useGetParams();
  const { voteActiveIdRef } = refs;
  const { setIsVisible, setCurrentState, setVoteState, setIsActive } = setters;

  const getVoteInfo = async () => {
    try {
      if (!user) {
        return;
      }

      const response = await fetch(
        `${protocol}//stream.iactive.pro/scr/getPollInfo.php?user=${user}&authorId=${authorId}`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;
      let { visibility, activity, id, authorVote } = data;

      voteActiveIdRef.current = id;

      if (authorVote !== undefined) {
        setVote(id, authorVote);
      }

      // Определяем активно ли голосование
      setIsActive(Boolean(Number(activity)));

      // Определяем видимость титра
      setIsVisible(Boolean(Number(visibility)));

      // Определяем состояние (S1, S2 ...)
      let newState = data?.state && getActiveState(data?.state);
      setCurrentState(newState);

      const equal = require('fast-deep-equal');

      if (!equal(voteState, data)) {
        setVoteState(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    getVoteInfo,
  };
};
